
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/prevision-cierre",
      function () {
        return require("private-next-pages/[region]/prevision-cierre.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/prevision-cierre"])
      });
    }
  